import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    CmpsButtonModule,
    CmpsChipModule,
    CmpsFilterModule,
    CmpsIconModule,
    CmpsPortalModule,
} from '@cmps/ng-uikit';

import { CmpsNoteModule } from '../../../../coaching-note/notes.module';
import { CmpsCommonModule } from '../../../../common/common.module';
import { CmpsDateRangeModule } from '../../../../common/component/date-range';
import { CmpsLazyI18nModule } from '../../../../i18n/i18n.module';

import { CommitmentNarrativeComponent } from './commitment-narrative.component';
import { TranslationIdMap } from './commitment-narrative.i18n';

@NgModule({
    imports: [
        CommonModule,
        CmpsCommonModule,
        FormsModule,
        ReactiveFormsModule,
        CmpsButtonModule,
        CmpsDateRangeModule,
        CmpsIconModule,
        CmpsNoteModule,
        CmpsChipModule,
        CmpsFilterModule,
        CmpsPortalModule,
        CmpsLazyI18nModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
    ],
    declarations: [CommitmentNarrativeComponent],
    exports: [CommitmentNarrativeComponent],
})
export class CmpsCommitmentNarrativeModule {}
